import React from 'react'
import { bool } from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import SearchOrLoading from './SearchOrLoading'
import MdClear from 'react-icons/lib/md/clear'

const SearchOrClear = ({ signs, clearSearch, history }) => (
  <div className="search-or-clear">
    {signs ? (
      <MdClear color="grey" onClick={() => history.push('/')} />
    ) : (
      <SearchOrLoading />
    )}
  </div>
)

SearchOrClear.propTypes = {
  signs: bool.isRequired,
}

const mapStateToProps = ({ signsState }) => ({
  signs: signsState.signs.length !== 0,
})

export default withRouter(connect(mapStateToProps)(SearchOrClear))



// WEBPACK FOOTER //
// ./src/components/Elements/AddressBar/SearchOrClear.jsx